import React from 'react';
import { Link } from 'react-router-dom';
import { MapPinIcon, BedIcon, BathIcon, CheckCircleIcon } from 'lucide-react';
interface PropertyCardProps {
  property: {
    id: number;
    title: string;
    location: string;
    price: string;
    bedrooms: number;
    bathrooms: number;
    area: string;
    image: string;
    verified: boolean;
    featured: boolean;
  };
}
const PropertyCard: React.FC<PropertyCardProps> = ({
  property
}) => {
  return <Link to={`/properties/${property.id}`} data-id="element-475">
      <div className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition" data-id="element-476">
        <div className="relative" data-id="element-477">
          <img src={property.image} alt={property.title} className="w-full h-48 object-cover" data-id="element-478" />
          {property.featured && <div className="absolute top-4 left-4 bg-green-600 text-white text-xs font-bold px-2 py-1 rounded" data-id="element-479">
              Featured
            </div>}
          <div className="absolute bottom-4 right-4 bg-white bg-opacity-90 text-green-600 font-bold px-3 py-1 rounded" data-id="element-480">
            {property.price}
          </div>
        </div>
        <div className="p-4" data-id="element-481">
          <div className="flex items-start justify-between" data-id="element-482">
            <h3 className="text-lg font-bold text-gray-800 mb-1" data-id="element-483">
              {property.title}
            </h3>
            {property.verified && <div className="flex items-center text-green-600" data-id="element-484">
                <CheckCircleIcon size={16} className="mr-1" data-id="element-485" />
                <span className="text-xs" data-id="element-486">Verified</span>
              </div>}
          </div>
          <div className="flex items-center text-gray-600 mb-3" data-id="element-487">
            <MapPinIcon size={16} className="mr-1" data-id="element-488" />
            <span className="text-sm" data-id="element-489">{property.location}</span>
          </div>
          <div className="border-t pt-3 mt-3" data-id="element-490">
            <div className="flex justify-between" data-id="element-491">
              <div className="flex items-center text-gray-700" data-id="element-492">
                <BedIcon size={16} className="mr-1" data-id="element-493" />
                <span className="text-sm" data-id="element-494">{property.bedrooms} Beds</span>
              </div>
              <div className="flex items-center text-gray-700" data-id="element-495">
                <BathIcon size={16} className="mr-1" data-id="element-496" />
                <span className="text-sm" data-id="element-497">{property.bathrooms} Baths</span>
              </div>
              <div className="flex items-center text-gray-700" data-id="element-498">
                <div size={16} className="mr-1" data-id="element-499" />
                <span className="text-sm" data-id="element-500">{property.area}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>;
};
export default PropertyCard;